// Modification of Material-UI's MobileStepper https://github.com/mui-org/material-ui/blob/next/packages/material-ui/src/MobileStepper/MobileStepper.js

import React from 'react'
import { createStyles, withStyles, Paper } from '@paintscout/ui'
import type { MobileStepperProps, MuiTheme as Theme, WithStyles } from '@paintscout/ui'
import classnames from 'classnames'
import type { EnhancedQuoteFile } from './FileView'

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: theme.palette.background.default,
      padding: 8,
      width: '100%'
    },
    dots: {
      display: 'flex',
      flexDirection: 'row',
      maxWidth: '75%'
    },
    dot: {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: '50%',
      width: 6,
      height: 6,
      marginTop: 1,
      marginLeft: 2,
      marginRight: 2
    },
    dotLastChild: {
      '&:last-child': {
        background: `
      linear-gradient(to bottom, transparent 35%, 
        ${theme.paintscout.palette.brand.Neutral.P80} 35%, 
        ${theme.paintscout.palette.brand.Neutral.P80} 65%,  
        transparent 65%),

      linear-gradient(to right, transparent 35%, 
        ${theme.paintscout.palette.brand.Neutral.P80} 35%, 
        ${theme.paintscout.palette.brand.Neutral.P80} 65%,  
        transparent 65%)
      `
      }
    },
    dotActive: {
      width: 8,
      height: 8,
      marginTop: 0,
      backgroundColor: theme.palette.primary.main,
      '&:last-child': {
        background: `
      linear-gradient(to bottom, transparent 35%, 
        ${theme.palette.primary.main} 35%, 
        ${theme.palette.primary.main} 65%,  
        transparent 65%),

      linear-gradient(to right, transparent 35%, 
        ${theme.palette.primary.main} 35%, 
        ${theme.palette.primary.main} 65%,  
        transparent 65%)
      `
      }
    },
    dotError: {
      backgroundColor: theme.palette.error.light,
      '&$dotActive': {
        backgroundColor: theme.palette.error.dark
      }
    },
    dotUploading: {
      '&:not($dotActive)': {
        animation: '2s infinite pulse'
      }
    },

    '@keyframes pulse': {
      '50%': {
        // transform: 'scale(1.1)',
        // backgroundColor: theme.palette.primary.light
      }
    }
  })

export interface ItemFilesStepperProps
  extends Omit<MobileStepperProps, 'classes' | 'steps'>,
    WithStyles<typeof styles> {
  files?: EnhancedQuoteFile[]
  addIcon?: boolean
}

function ItemFilesStepper(props: ItemFilesStepperProps) {
  const { activeStep, backButton, classes, className, nextButton, files, addIcon } = props

  const steps = (files ? files.length : 0) + (addIcon ? 1 : 0)
  return (
    <Paper square elevation={0} className={classnames(classes.root, className)}>
      {backButton}
      <div className={classes.dots}>
        {Array.from({ length: steps }).map((_, index) => {
          return (
            <div
              key={index}
              className={classnames(classes.dot, {
                [classes.dotActive]: index === activeStep,
                [classes.dotError]: files[index] && !!files[index].error,
                [classes.dotUploading]: files[index] && files[index].uploading,
                [classes.dotLastChild]: addIcon
              })}
            />
          )
        })}
      </div>
      {nextButton}
    </Paper>
  )
}

export default withStyles(styles)(ItemFilesStepper)
